import {FeatureAppDefinition, FeatureServices} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import {BreadcrumbServiceV1} from '@volkswagen-onehub/breadcrumb-service';
import {ThemeProvider} from '@ngw6/us-components';
import React from 'react';
import {App} from './app';

export interface BreadcrumbsFeatureAppDependencies extends FeatureServices {
  readonly 'breadcrumb-service': BreadcrumbServiceV1;
}

export interface BreadcrumbsFeatureAppConfig {
  readonly breadcrumbConsumerIds: string[];
}

export const breadcrumbsFeatureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  BreadcrumbsFeatureAppDependencies,
  BreadcrumbsFeatureAppConfig
> = {
  dependencies: {
    featureServices: {
      'breadcrumb-service': '^1.0.0',
    },
  },

  create: ({featureServices, config}) => {
    if (!config?.breadcrumbConsumerIds) {
      throw new Error(
        'No breadcrumbConsumerIds provided as Feature App Config.',
      );
    }

    return {
      render: () => (
        <ThemeProvider theme="main">
          <App
            breadcrumbService={featureServices['breadcrumb-service']}
            breadcrumbConsumerIds={config.breadcrumbConsumerIds}
          />
        </ThemeProvider>
      ),
    };
  },
};

export default breadcrumbsFeatureAppDefinition;
